<template>
  <v-card flat class="mx-auto mt-8">
    <v-row align="center" justify="center">
      <v-col md="6" :order="order">
        <v-card flat :max-width="maxWidth">
          <v-card-text class="text-md-h3 text-sm-h4 text-h4 mt-md-12 mt-4 font-weight-medium">
            <span :style="`color:${partnerColorDarkmode}`">
              {{ $t(headline) }}
            </span>
          </v-card-text>
        </v-card>
        <v-card flat max-width="600">
          <v-card-text class="text-md-h6 text-sm-h6 text-body-2 font-weight-regular" v-html="$t(description)" />
        </v-card>
      </v-col>
      <v-col align="center" justify="center" cols="12" md="6">
        <slot />
      </v-col>
    </v-row>
  </v-card>
</template>

<script lang="ts">
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class DescriptionCard extends Vue {
  @Prop({ default: 800 })
  maxWidth!: number;

  @Prop()
  headline!: "";

  @Prop()
  description!: "";

  /**
   * Use this Prob to configure the order of the Text and the image
   */
  @Prop({ default: false })
  reverse!: boolean;

  @Prop({ default: "text-caption font-weight-light" })
  textStyle!: string;

  get color() {
    return getDefaultPartnerColor();
  }

  /**
   * Returns the order of the text and the image.
   * Last means, image is to the right side (or on mobile under the text; on mobile always returns last)
   * First means, image is to the left side (or on mobile above the text)
   */
  get order(): string {
    if (this.reverse && !["xs", "sm"].includes(this.$vuetify.breakpoint.name)) {
      return "last";
    }
    return "first";
  }

  get partnerColorDarkmode() {
    return this.$vuetify.theme.dark ? "white" : this.color;
  }
}
</script>
